import { useSiteMetadata } from "component_old/seo/use-site-metadata"
import React from "react"

interface Props {
  title?: string
  description?: string
  pathname: string
  image?: string
  children?: JSX.Element
}

export const SEO = ({
  title,
  description,
  pathname,
  image,
  children,
}: Props): JSX.Element => {
  const {
    title: defaultTitle,
    description: defaultDescription,
    image: defaulImage,
    siteUrl,
  } = useSiteMetadata()

  const seo = {
    title: "Mapheim - Engaging Apps & Maps for your visitors",
    description:
      "Elevate your location with a digital solution that enhances navigation, boosts engagement, and helps creating memorable visitor experiences",
    image: image || defaulImage,
    url: `${siteUrl}${pathname || ``}`,
  }

  return (
    <>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:url" content={seo.url} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />

      <meta property="og:title" content={seo.title} />
      <meta property="og:type" content="website" />
      <meta name="image" property="og:image" content={seo.image} />
      <meta property="og:url" content={seo.url} />
      <meta property="og:description" content={seo.description} />

      <meta id="robots" name="robots" content="index, follow" />

      <link rel="preconnect" href="https://api2.amplitude.com" />
      <link rel="dns-prefetch" href="https://api2.amplitude.com" />
      {children}
    </>
  )
}
